import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import queryString from "query-string";
import Header from "../../partials/header";
import CustomerFeedbackList from "./list";
import CustomerFeedbackEditForm from "./editForm";
import Snackbar from "../snackbar";
import Loading from "../loading";
import { styles } from "./styles";
class CustomerFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showList: true,
      list: [],
      newFeedback: {
        serviceCode: "",
        name: "",
        avatar: "",
        countryCode: "",
        phone: "",
        text: "",
        createdAt: Date.now(),
        email: "",
        socialNetwork: {
          facebook: "",
          instagram: "",
          twitter: "",
        },
      },
      selectedFeedback: null,
    };
    this.getHeader = this.getHeader.bind(this);
    this.getList = this.getList.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.remove = this.remove.bind(this);
  }

  async componentDidMount() {
    const { location } = this.props;
    if (location.search === "") {
      await this.props.history.push({
        search: queryString.stringify({
          page: 1,
          pageSize: 5,
        }),
      });
    }
    await this.getList();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevLocation = prevProps.location;
    const { location } = this.props;
    if (prevLocation.search !== location.search) {
      this.getList();
    }
  }
  async getList() {
    let { search } = this.props.location;
    search = queryString.parse(search);
    this.loading.startLoading();
    const response = await this.props.getListFeedback(search);
    this.loading.stopLoading();
    if (response.code === 1) {
      this.setState({ list: response.data });
    }
  }
  async update(param) {
    const { t } = this.props;
    const response = await this.props.updateFeedback(param);
    if (response.code !== 1) {
      this.mSnackbar.handleClick(
        t("An_error_occurred_Please_check_internet_or_contact_your_admin"),
        "warning"
      );
      this.loading.stopLoading();
      return false;
    }
    this.mSnackbar.handleClick(t("customer_add_feedback_updated"), "success");
    this.getList();
  }
  async create(param) {
    const { t } = this.props;

    let { search } = this.props.location;
    search = queryString.parse(search);
    const response = await this.props.createFeedback(param);
    this.setState({
      showList: true,
    });
    if (response.code !== 1) {
      this.mSnackbar.handleClick(
        t("An_error_occurred_Please_check_internet_or_contact_your_admin"),
        "warning"
      );
      this.loading.stopLoading();
      return false;
    }

    if (parseInt(search.page) === 1) {
      await this.getList();
      return null;
    }

    this.mSnackbar.handleClick(t("customer_add_feedback_created"), "success");
    this.props.history.push({
      search: queryString.stringify({
        page: 1,
        pageSize: 5,
      }),
    });
    return true;
  }

  async remove(id) {
    this.loading.startLoading();
    const { t } = this.props;
    const response = await this.props.deleteFeedback(id);
    this.loading.stopLoading();
    if (response.code !== 1) {
      this.mSnackbar.handleClick(
        t("An_error_occurred_Please_check_internet_or_contact_your_admin"),
        "warning"
      );

      return null;
    }
    this.mSnackbar.handleClick(t("customer_add_feedback_deleted"), "success");
    await this.getList();
  }
  async submitForm(param) {
    this.loading.startLoading();
    if (this.state.selectedFeedback) {
      await this.update(param);
    } else {
      await this.create(param);
    }
    this.loading.stopLoading();
  }
  getHeader() {
    const { t } = this.props;
    const { showList, selectedFeedback } = this.state;
    const session = showList ? t("cms") : t("customer_feedback_list");
    let title = t("customer_feedback_list");
    if (!selectedFeedback && !showList) {
      title = t("customer_add_feedback");
    } else if (selectedFeedback && !showList) {
      title = t("customer_edit_feedback");
    }
    const actionBack = !showList
      ? () => {
          this.setState({
            showList: !showList,
          });
        }
      : null;
    const actionButton = showList
      ? () => {
          this.setState({
            showList: !showList,
            selectedFeedback: null,
          });
        }
      : null;
    return {
      session,
      title,
      actionBack,
      actionButton,
    };
  }
  render() {
    const { t, classes, history } = this.props;
    const { showList, newFeedback, list, selectedFeedback } = this.state;
    const header = this.getHeader();

    return (
      <div>
        <div className={classes.headerContainer}>
          <Header
            session={header.session}
            title={header.title}
            button={showList ? t("customer_add_feedback") : null}
            backIcon={!showList}
            actionBack={header.actionBack}
            actionButton={header.actionButton}
          />
        </div>

        <Loading
          onRef={(id) => {
            this.loading = id;
          }}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        {showList ? (
          <CustomerFeedbackList
            list={list}
            history={history}
            remove={this.remove}
            selectFeedback={(selectedFeedback) => {
              this.setState({
                selectedFeedback,
                showList: !showList,
              });
            }}
          />
        ) : (
          <Paper className={classes.editFormWrapper} elevation={3}>
            <CustomerFeedbackEditForm
              feedback={selectedFeedback ? selectedFeedback : newFeedback}
              history={history}
              onSubmit={(param) => {
                this.submitForm(param);
              }}
              onReset={() => {
                this.setState({
                  showList: !showList,
                });
              }}
              uploadAvatar={(data) => {
                this.loading.startLoading();
                return this.props.saveStorage(data);
              }}
            />
          </Paper>
        )}
      </div>
    );
  }
}
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({
  getListFeedback: dispatch.customerFeedback.getListFeedback,
  updateFeedback: dispatch.customerFeedback.updateFeedback,
  createFeedback: dispatch.customerFeedback.createFeedback,
  deleteFeedback: dispatch.customerFeedback.deleteFeedback,
  saveStorage: dispatch.upload.saveStorage,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(CustomerFeedback)));
